import React from 'react';
import { Form } from 'antd';
import PropsType from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import InputComponent from '@/components/Input';
import ButtonComponent from '@/components/Button';
import { ENV, ROUTES } from '@/constants';

import './index.scss';
import { getCurrentLanguage } from '@/utils/locale';

function ResetPassword({ onSubmit, isLoading, isVerify }) {
  const { t: translation } = useTranslation();
  const navigate = useNavigate();
  const listItem = [
    translation('login.banner.1'),
    translation('login.banner.2'),
    translation('login.banner.3'),
    translation('login.banner.4'),
    translation('login.banner.5'),
    translation('login.banner.6'),
  ];

  const renderItem = (key, item) => (
    <div key={key} className="forgot-page__item">
      <span className="check-icon" />
      <p className="mb-0">{item}</p>
    </div>
  );

  const handleResetPassword = (e) => {
    onSubmit(e);
  };

  const openLink = (path) => {
    navigate(path);
  };

  const lang = getCurrentLanguage();
  const websiteURLBaseOnLanguage =
    lang === 'th' ? ENV.WEBSITE_URL : `${ENV.WEBSITE_URL}/${lang}`;

  return (
    <div className="forgot-page">
      <div className="forgot-page__container">
        <div className="forgot-page__left">
          <div className="logo-wrapper">
            <a href={websiteURLBaseOnLanguage}>
              <div className="logo" />
            </a>
          </div>
          <div className="forgot-page__title">{translation('login.title')}</div>
          <div className="forgot-page__left__group">
            {listItem.map((item, key) => renderItem(key, item))}
          </div>
        </div>
        <div className="forgot-page__right">
          <div className="forgot-page__right__form">
            <div
              className="forgot-page__backlink"
              role="button"
              aria-hidden="true"
              onClick={() => openLink(ROUTES.LOGIN_PATH)}
            >
              <span className="forgot-page__icon-back" />
              {translation('forgot_password.form.back')}
            </div>
            {!isVerify && (
              <>
                <span className="forgot-page__error-icon" />
                <h1 className="forgot-page__right__title text-center">
                  {translation('forgot_password.not_verify.title')}
                </h1>
              </>
            )}
            {isVerify && (
              <>
                <h1 className="forgot-page__right__title">
                  {translation('forgot_password.form.update_password')}
                </h1>
                <Form
                  className="forgot-page__right__form__container"
                  name="resetPassword-form"
                  layout="vertical"
                  onFinish={handleResetPassword}
                  autoComplete="off"
                >
                  <Form.Item
                    name="newPassword"
                    rules={[
                      {
                        required: true,
                        message: translation(
                          'login.form.errors.password.required',
                        ),
                      },
                    ]}
                  >
                    <InputComponent
                      placeholder={translation(
                        'login.form.placeholder.password',
                      )}
                      label={translation('login.form.fields.password')}
                      type="password"
                    />
                  </Form.Item>

                  <Form.Item className="forgot-page__submit-btn">
                    <ButtonComponent
                      loading={isLoading}
                      type="primary"
                      htmlType="submit"
                    >
                      Submit
                    </ButtonComponent>
                  </Form.Item>
                </Form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

ResetPassword.propTypes = {
  onSubmit: PropsType.func,
  isLoading: PropsType.bool,
  isVerify: PropsType.bool,
};

export default ResetPassword;
